import styled from "styled-components";
import { transformPrice } from "../utils/transformPrice";

interface IProps {
  name: string;
  price: number;
  barFillerPercentage: number;
  isVibb?: boolean;
  isProviderSelected?: boolean;
}

const BarChartItem = ({
  name,
  price,
  barFillerPercentage,
  isVibb = false,
  isProviderSelected = false,
}: IProps) => {
  return (
    <BarItemContainer isProviderSelected={isProviderSelected}>
      <BarBackground isVibb={isVibb} isProviderSelected={isProviderSelected}>
        <BarFiller height={barFillerPercentage} isVibb={isVibb} />
      </BarBackground>
      <ProviderInfo>
        <Name>{name}</Name>
        <Price>{transformPrice(price)}</Price>
      </ProviderInfo>
    </BarItemContainer>
  );
};

export default BarChartItem;

const BarItemContainer = styled.div<{ isProviderSelected: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: ${({ isProviderSelected }) => (isProviderSelected ? "36px" : "0")};
  }
`;

const ProviderInfo = styled.div`
  text-align: center;
  margin-top: 10px;
`;
const Price = styled.div`
  font-family: "RiposteLight";
`;
const Name = styled.div`
  font-family: "RiposteBold";
  font-size: 16px;
  line-height: 19px;
`;

const BarBackground = styled.div<{
  isVibb: boolean;
  isProviderSelected: boolean;
}>`
  position: relative;
  width: ${({ isProviderSelected }) => (isProviderSelected ? "99px" : "44px")};
  height: 300px;
  border-radius: 9px;
  outline: ${({ isVibb }) =>
    isVibb ? "2px solid #43E695" : "2px solid #1cb3fb"};
`;

const BarFiller = styled.div<{ height: number; isVibb?: boolean }>`
  width: 100%;
  height: ${({ height }) => `${height}%`};
  border-radius: 4px;
  background: ${({ isVibb }) => (isVibb ? "#43E695" : "#1cb3fb")};
  position: absolute;
  bottom: 0;

  transition: height 0.2s ease-in;
`;
